





































import { defineComponent, onBeforeUnmount, onMounted, ref, useContext, useFetch } from '@nuxtjs/composition-api'
import { PropType } from 'vue';
import { ProductForProductPageType } from '~/utils/types/ProductPage';
import axios from 'axios';
import { getAxiosConfigs } from '~/utils/solepro/functions';
import { useConfig } from '~/composables';
import OfferGroup from './OfferGroup.vue';
import { Pagination, Navigation } from 'swiper'
import { Swiper, SwiperSlide } from 'swiper-vue2'
import { CONFIGURABLE_TYPE_ID } from '~/utils/constants/product';
import { getGroupInfos } from '~/utils/helpers/product';
import PaymentMethodsIcons from '../../PaymentMethodsIcons.vue';
import { equalizePurchaseSlides, observeScalapay } from '~/utils/helpers/solepro/product';
export default defineComponent({
    props: {
        product: {
            type: Object as PropType<ProductForProductPageType>,
            required: true
        }
    },
    components: {
        OfferGroup,
        Swiper,
        SwiperSlide,
        PaymentMethodsIcons
    },
    setup(props) {
        const isSSR = ref(true);
        const groups = ref([])
        const { app } = useContext();
        const { config } = useConfig();
        /** @TODO manage component loader */
        useFetch(async () => {

            const skus = props.product.offer_groups.map(el => el.skus.split(',')).flat()
            const { data: groupskus } = await axios.post('/sole-api/product/pro/getOfferGroupsProducts', { skus }, { ...getAxiosConfigs(app, config) })
            groups.value = props.product.offer_groups.map(group => {
                return getGroupInfos(group, groupskus)
            });
            
        })
        const swiperProps = {
            modules: [Navigation, Pagination],
            slideClass: "slide",
            navigation: {
                prevEl: '.section-purchase-options .navigation-prev',
                nextEl: '.section-purchase-options .navigation-next',
            },
            spaceBetween: 20,
            slidesPerView: 3,
            slidesPerGroup: 3,
            direction: "horizontal",
            loop: false, // Disabilita il loop
            breakpoints: {
                0: { 
                    enabled: false,
                    // Inizia da 0px fino a 1024px
                    slidesPerView: 'auto', // Mostra una slide per riga (o auto a seconda del contenuto)
                    freeMode: true, // Permette lo scroll libero senza snap delle slide
                    navigation: false, // Disabilita le frecce
                    allowTouchMove: true, // Permette lo scorrimento
                    grabCursor: false, // Non mostra il cursore di "mano"
                    direction: "vertical",
                },
                1024: {
                    enabled: true,
                    slidesPerView: 'auto',
                    direction: "horizontal",
                    allowTouchMove: true,
                    grabCursor: true,
                    freeMode: false,

                }
            },
        }
          /* const handleResize = () => {
            useCarousel.value = groups.value.length > 3 && window.innerWidth >= 1024
        }*/
        const cardsQty = ref(0)
        onMounted(() => { 
            isSSR.value=false;
            /*handleResize()           
            useCarousel.value = groups.value.length > 3 && window.innerWidth >= 1024
            window.addEventListener('resize', handleResize);*/
            cardsQty.value = Array.from(document.querySelectorAll('[data-component="productPurchaseOptions"]')).length
        })
        /*onBeforeUnmount(() => {
            window.removeEventListener('resize', handleResize)

        })*/
        return {
            groups,
            swiperProps,
            //useCarousel,
            isSSR
        }
    },
    methods:{
        
        calculateHeights(swiper) {
            if(window.innerWidth<1024) return;
            const slides = swiper.$el[0].querySelectorAll('.slide');
            const tallest = Array.from(slides).reduce((tallest: Element, slide: Element) => {
                return slide.querySelector('.solepro-offers-group').getBoundingClientRect().height > tallest.querySelector('.solepro-offers-group').getBoundingClientRect().height ? slide : tallest;
            });
            const h = (tallest as HTMLElement).offsetHeight + 'px';
            slides.forEach(el => el.querySelector('.solepro-offers-group').style.height = h)
        },
        afterInit(swiper) {
            if(window.innerWidth<1024) return;
            observeScalapay(swiper.$el[0], ()=> this.$nextTick(()=>equalizePurchaseSlides(swiper)))
            setTimeout(() => {
                equalizePurchaseSlides(swiper);
            }, 100);
        },
        onSwiperResize(swiper) {
            equalizePurchaseSlides(swiper);
            console.log('swiper resized');
        },
    }
})
